import { moveMediaElementZindexBottomAction } from 'editor/src/store/design/slice';
import { ElementAddress } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const moveMediaElementZindexBottomOperation = (elementAddress: ElementAddress) => (dispatch: ThunkDispatch) =>
  dispatch(moveMediaElementZindexBottomAction(elementAddress));

export default moveMediaElementZindexBottomOperation;
